import { GET_APWINDOWS, GET_APWINDOW, DELETE_APWINDOW } from '../actions/apwindowsActions';
import { GET_APWINDOW_NOTIFICATION } from '../actions/apwindowNotificationsActions';

/**
 * Manejo de la parte del estado correspondiente a examenes.
 * Permite la actualización de examenes, obtener un examen por id.
 * Permite eliminar un examen por id.
 *
 * @export
 * @param {*} [state={}] : estado de la aplicación
 * @param {*} action : operación a realizar sobre el estado (correspondiente a las preguntas de examen)
 * @returns El estado con la modificación/acción realizada.
 */
const initialState = {
  apwindows: [],
  apwindow: undefined,
  apwindowNotification: undefined,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_APWINDOWS:
      return {...state,
        apwindows: action.payload 
      };
    case GET_APWINDOW:
      return {...state,
        apwindow: action.payload 
      };
    case DELETE_APWINDOW:
      return {...state,
        apwindow: undefined 
      };
    case GET_APWINDOW_NOTIFICATION:
      return {...state,
        apwindowNotification: action.payload 
      };
    default:
      return state;
  }
}
